export default __webpack_public_path__ + "static/media/resume.3f878b39.jpg";